import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import MemberProfile from "./MemberProfile"; // Adjust path if needed

export default function MemberProfilePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { id } = useParams(); // React Router gives route params like this

  const section = searchParams.get("section") || "members";
  const isContact = section === "contacts";

  const handleBack = () => {
    navigate(-1); // Equivalent to router.back()
  };

  return (
    <MemberProfile
      memberId={id!}
      isContact={isContact}
      section={section}
      onBack={handleBack}
    />
  );
}